import { useEffect, useRef, useState } from 'react';

//The single-choice counterpart to MultiSelectDropdown: same pill and panel, but the pill names the
//chosen option and picking one closes the panel.
const SelectDropdown = ({ options, selected, onChange, emptyLabel, disabled = false }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const selectedOption = options.find(option => option.value === selected);

  return (
    <div ref={wrapperRef} className='relative w-fit'>
      <button
        type='button'
        disabled={disabled}
        onClick={() => setShowDropdown(!showDropdown)}
        className={`flex items-center gap-1 h-[40px] pl-3 pr-2 rounded border bg-white text-sm font-[450] disabled:bg-disabled-gray disabled:text-opaque-job-details-gray disabled:border-navy-light ${
          selectedOption ? 'border-dark-blue text-dark-blue' : 'border-navy-light text-gray-blue'
        }`}
      >
        <span className='select-none'>{selectedOption ? selectedOption.label : emptyLabel}</span>
        <img
          src={showDropdown ? '/show_less_arrow.svg' : '/show_more_arrow.svg'}
          alt=''
          className='h-[20px]'
        />
      </button>

      <div
        className={`absolute z-10 mt-1 w-[280px] max-h-[300px] overflow-y-auto flex flex-col p-[8px] bg-white border border-navy-light rounded-[8px] shadow-md text-sm ${
          showDropdown ? '' : 'hidden'
        }`}
      >
        {options.map(option => (
          <button
            key={option.value}
            type='button'
            onClick={() => {
              onChange(option.value);
              setShowDropdown(false);
            }}
            className={`flex w-full items-start p-[8px] text-left rounded hover:bg-gray-light ${
              option.value === selected ? 'bg-gray-light font-semibold' : ''
            }`}
          >
            <span className='select-none text-dark-blue'>{option.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SelectDropdown;
